import { TeammateRelationship } from "src/views/hacker-directory/shared/types";

interface RelationshipCopyArgs {
  relationship: TeammateRelationship;
  profileOwnerName?: string | null;
  teammateName: string;
  isOwnProfile: boolean;
}

export const getRelationshipCopy = ({
  relationship,
  profileOwnerName,
  teammateName,
  isOwnProfile,
}: RelationshipCopyArgs): string | null => {
  const ownerLabel = profileOwnerName?.trim() || "This hacker";
  const teammateLabel = teammateName.trim() || "this teammate";

  if (relationship === "mutual") {
    return isOwnProfile
      ? `You and ${teammateLabel} have added each other as teammates.`
      : `${ownerLabel} and ${teammateLabel} have added each other as teammates.`;
  }

  if (relationship === "pending") {
    return isOwnProfile
      ? `You added ${teammateLabel} as a teammate, but ${teammateLabel} hasn’t added you back.`
      : `${ownerLabel} added ${teammateLabel} as a teammate, but ${teammateLabel} hasn’t added ${ownerLabel} back.`;
  }

  return null;
};
